import React from "react";
import { Button } from "semantic-ui-react";
import useConveyorBoxHandlers from "../../../hooks/useConveyorBoxHandlers";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { IConveyorBox } from "../../../lib/interfaces/ConveyorBox/IConveyorBox";

type Props = {};

type ConveyorBoxState = IConveyorBox & {
  requestNewShippingLabelFailed?: boolean;
};

const RequestNewShippingLabelInAutomationButton = (props: Props) => {
  const { onRequestNewShippingLabelHandler, onChangeLabelInAutomationHandler } =
    useConveyorBoxHandlers();

  const conveyorBoxReview = useSelector(
    (state: any) => state.conveyorBoxReviewReducer as ConveyorBoxState
  );

  const showChangeLabelButton =
    !!conveyorBoxReview.requestNewShippingLabelFailed &&
    conveyorBoxReview.vendor?.shopId !== 29;

  return (
    <>
      <Button
        content="Skicka ny fraktetikett till automationen"
        size="big"
        aria-label="skicka ny fraktetikett till automationen"
        icon="send"
        onClick={onRequestNewShippingLabelHandler}
      />

      {showChangeLabelButton && (
        <Button
          content="Ändra till Posten MyPack & skicka till automationen"
          size="big"
          aria-label="skriv ut ny fraktetikett"
          icon="sync alternate"
          color="blue"
          onClick={onChangeLabelInAutomationHandler}
        />
      )}
    </>
  );
};

export default RequestNewShippingLabelInAutomationButton;
